import { SrkInquiry } from "./components";

export const ContactComponents = () => {
    return(
        <>
            <SrkInquiry />
        </>
    )
};